import { useForm } from '@mantine/form';

import { TDateRange } from '@/shared/types/app.types.ts';
import { IGuest } from '@/shared/types/booking.types.ts';
import { BookingType } from '@/shared/types/bookingObjects.types.ts';

type BookingEditFormType = {
	date: TDateRange;
	booking_object_id: number | null;
	client_id: number | null;
	kind: BookingType | null;
	initiator_id: number | null;
	pass_id?: number | null;
	car_number?: string | null;
	is_guest?: boolean | null;
	guests?: IGuest[];
	additional_clients_id?: number[];
};

export const useBookingEditForm = () => {
	const form = useForm<BookingEditFormType>({
		initialValues: {
			date: [null, null],
			booking_object_id: null,
			client_id: null,
			kind: null,
			initiator_id: null,
			pass_id: null,
			car_number: null,
			is_guest: null,
			guests: [],
			additional_clients_id: [],
		},
	});
	return form;
};
